const settingNames = {
  hu: {
    // Setting names
    Szélesség: "Szélesség",
    Magasság: "Magasság",
    Mélység: "Mélység",
    "Oldalról van csavarva": "Oldalról van csavarva",
    "Fiókok száma - sor": "Fiókok száma - sor",
    "Fiókok száma - oszlop": "Fiókok száma - oszlop",
    "Szokli szélesség": "Szokli szélesség",
    "Van szokli?": "Van szokli?",
    "Duplungolt vendéglap?": "Duplungolt vendéglap?",
    "Duplungolt blat?": "Duplungolt blat?",
    "Kell vendéglap?": "Kell vendéglap?",
    "Blat túllógás": "Blat túllógás",
    "Fiók szélessége": "Fiók szélessége",
    "Kell válaszfal?": "Kell válaszfal?",
    "Válaszfalak száma": "Válaszfalak száma",
    "Ajtó szélessége": "Ajtó szélessége",
    "Nagy ágyvég kilógás": "Nagy ágyvég kilógás",
    "Matrac szélesség": "Matrac szélesség",
    "Matrac hosszúság": "Matrac hosszúság",
    "Matrac magasság": "Matrac magasság",
    "Kötés vastagság": "Kötés vastagság",
    "Ajtók száma": "Ajtók száma",
    "Matrac kilógás": "Matrac kilógás",
    "Bal oldali fiókok száma": "Bal oldali fiókok száma",
    "Jobb oldali fiókok száma": "Jobb oldali fiókok száma",
    "Fiókok száma szemből": "Fiókok száma szemből",
    "Fiók magassága": "Fiók magassága",
    "Kötések száma": "Kötések száma",
    "Duplung - kötés szélesség": "Duplung - kötés szélesség",
    "Polcok száma": "Polcok száma",
    "Sütő magasság": "Sütő magasság",
    "Fiókok száma": "Fiókok száma",
    "Kötés közötti távolság": "Kötés közötti távolság",
    "Nagy szekrény szélessége": "Nagy szekrény szélessége",
    "Nagy szekrény mélysége + kis szekrény szélessége":
      "Nagy szekrény mélysége + kis szekrény szélessége",
    "Mikró magasság": "Mikró magasság",
    "Felső rész magasság": "Felső rész magasság",
    "Duplungolt oldalak?": "Duplungolt oldalak?",
    "Duplungolt ágyvégek?": "Duplungolt ágyvégek?",
    "Nagy ágyvég függőleges kilógása": "Nagy ágyvég függőleges kilógása",
    "Hosszú merevítések száma": "Hosszú merevítések száma",
    "Rövid merevítések száma": "Rövid merevítések száma",
    "Jobb oldali fiókszélesség": "Jobb oldali fiókszélesség",
    "Bal oldali fiókszélesség": "Bal oldali fiókszélesség",
    "Duplung - tömör": "Duplung - tömör",
    "Mindent láthatót kantolni": "Mindent láthatót kantolni",
    "Plafon kötéssel": "Plafon kötéssel",
    "Van hátlemez": "Van hátlemez",
    "Van láb": "Van láb",
    "Elforgatott kötések": "Elforgatott kötések",
    "Oldalak közé zár": "Oldalak közé zár",
    "Bal oldali kis szekrény": "Bal oldali kis szekrény",
    "Szemben lévő fiókok szélessége": "Szemben lévő fiókok szélessége",
    "Fiók mélység": "Fiók mélység",
    "Plafon/Fenék darabszám": "Plafon/Fenék darabszám",
    "Blat kilógás": "Blat kilógás",
    "Hátlemez darabok": "Hátlemez darabok",
    "Rész kiosztás": "Rész kiosztás",
    "Belső rész kiosztás": "Belső rész kiosztás",
    "Fiókos rész magassága": "Fiókos rész magassága",
    "Fiókok közötti távolság": "Fiókok közötti távolság",
    "Fiókos rész alatti távolság": "Fiókos rész alatti távolság",
    "Válfás rész magassága": "Válfás rész magassága",
    "Felső polcok száma": "Felső polcok száma",
    "Alsó polcok száma": "Alsó polcok száma",
    "Középső polcok száma": "Középső polcok száma",
    "Válfák száma": "Válfák száma",
    "Alsó rész magassága": "Alsó rész magassága",
    "Belső rész típusok": "Belső rész típusok",
    "Ajtó kilógás": "Ajtó kilógás",
    "Első ajtók száma": "Első ajtók száma",
    "Hátsó ajtók száma": "Hátsó ajtók száma",
    "Első ajtó pozíciója": "Első ajtó pozíciója",
    "Kötés magassága": "Kötés magassága",
    Balos: "Balos",
    "Fiókos rész szélessége": "Fiókos rész szélessége",
    "Felső fiók magasság": "Felső fiók magasság",
    Vízszintes: "Vízszintes",

    // Setting values
    Igen: "Igen",
    Nem: "Nem",
    Polcok: "Polcok",
    "Fiókos és polcos": "Fiókos és polcos",
    "Fiókos és Válfás": "Fiókos és Válfás",
    "Válfás és polcos": "Válfás és polcos",
    Elől: "Elől",
    Hátul: "Hátul",
    "Fiókelő és fiókoldal különbség": "Fiókelő és fiókoldal különbség"
  },
  ro: {
    Szélesség: "Lățime",
    Magasság: "Înălțime",
    Mélység: "Adâncime",
    "Oldalról van csavarva": "Înșurubat din lateral",
    "Fiókok száma - sor": "Nr. sertare - rând",
    "Fiókok száma - oszlop": "Nr. sertare - coloană",
    "Szokli szélesség": "Lățime soclu",
    "Van szokli?": "Are soclu?",
    "Duplungolt vendéglap?": "Panou dublu?",
    "Duplungolt blat?": "Blat dublu?",
    "Kell vendéglap?": "Este necesar panoul?",
    "Blat túllógás": "Depășire blat",
    "Fiók szélessége": "Lățime sertar",
    "Kell válaszfal?": "Este necesară despărțitura?",
    "Válaszfalak száma": "Nr. pereți despărțitori",
    "Ajtó szélessége": "Lățime ușă",
    "Nagy ágyvég kilógás": "Depășire tăblie mare",
    "Matrac szélesség": "Lățime saltea",
    "Matrac hosszúság": "Lungime saltea",
    "Matrac magasság": "Înălțime saltea",
    "Kötés vastagság": "Grosime legătură",
    "Ajtók száma": "Nr. uși",
    "Matrac kilógás": "Depășire saltea",
    "Bal oldali fiókok száma": "Nr. sertare stânga",
    "Jobb oldali fiókok száma": "Nr. sertare dreapta",
    "Fiókok száma szemből": "Nr. sertare din față",
    "Fiók magassága": "Înălțime sertar",
    "Kötések száma": "Nr. legături",
    "Duplung - kötés szélesség": "Dublură - lățime legătură",
    "Polcok száma": "Nr. polițe",
    "Sütő magasság": "Înălțime cuptor",
    "Fiókok száma": "Nr. sertare",
    "Kötés közötti távolság": "Distanță între legături",
    "Nagy szekrény szélessége": "Lățime dulap mare",
    "Nagy szekrény mélysége + kis szekrény szélessége":
      "Adâncime dulap mare + lățime dulap mic",
    "Mikró magasság": "Înălțime microunde",
    "Felső rész magasság": "Înălțime parte superioară",
    "Duplungolt oldalak?": "Laterale duble?",
    "Duplungolt ágyvégek?": "Tăblii duble?",
    "Nagy ágyvég függőleges kilógása": "Depășire verticală tăblie mare",
    "Hosszú merevítések száma": "Nr. rigidizări lungi",
    "Rövid merevítések száma": "Nr. rigidizări scurte",
    "Jobb oldali fiókszélesség": "Lățime sertar dreapta",
    "Bal oldali fiókszélesség": "Lățime sertar stânga",
    "Duplung - tömör": "Dublură - plin",
    "Mindent láthatót kantolni": "Cantare tot ce se vede",
    "Plafon kötéssel": "Plafon cu legătură",
    "Van hátlemez": "Are spate",
    "Van láb": "Are picior",
    "Elforgatott kötések": "Legături rotite",
    "Oldalak közé zár": "Blocat între laterale",
    "Bal oldali kis szekrény": "Dulap mic stânga",
    "Szemben lévő fiókok szélessége": "Lățime sertare față-față",
    "Fiók mélység": "Adâncime sertar",
    "Plafon/Fenék darabszám": "Nr. plafon/fund",
    "Blat kilógás": "Depășire blat",
    "Hátlemez darabok": "Bucăți spate",
    "Rész kiosztás": "Distribuție compartiment",
    "Belső rész kiosztás": "Distribuție interior",
    "Fiókos rész magassága": "Înălțime compartiment sertare",
    "Fiókok közötti távolság": "Distanță între sertare",
    "Fiókos rész alatti távolság": "Distanță sub compartiment sertare",
    "Válfás rész magassága": "Înălțime compartiment cuiere",
    "Felső polcok száma": "Nr. polițe superioare",
    "Alsó polcok száma": "Nr. polițe inferioare",
    "Középső polcok száma": "Nr. polițe mijlocii",
    "Válfák száma": "Nr. cuiere",
    "Alsó rész magassága": "Înălțime parte inferioară",
    "Belső rész típusok": "Tipuri compartiment interior",
    "Ajtó kilógás": "Depășire ușă",
    "Első ajtók száma": "Nr. uși față",
    "Hátsó ajtók száma": "Nr. uși spate",
    "Első ajtó pozíciója": "Poziție primă ușă",
    "Kötés magassága": "Înălțime legătură",
    Balos: "Stânga",
    "Fiókos rész szélessége": "Lățime compartiment sertare",
    "Felső fiók magasság": "Înălțime sertar superior",
    Vízszintes: "Orizontal",

    Igen: "Da",
    Nem: "Nu",
    Polcok: "Polițe",
    "Fiókos és polcos": "Sertare și polițe",
    "Fiókos és Válfás": "Sertare și cuiere",
    "Válfás és polcos": "Cuiere și polițe",
    Elől: "Față",
    Hátul: "Spate",
    "Fiókelő és fiókoldal különbség": "Diferență față sertar și lateral sertar"
  },
  en: {
    Szélesség: "Width",
    Magasság: "Height",
    Mélység: "Depth",
    "Oldalról van csavarva": "Screwed from side",
    "Fiókok száma - sor": "Drawer count - row",
    "Fiókok száma - oszlop": "Drawer count - column",
    "Szokli szélesség": "Plinth width",
    "Van szokli?": "Has plinth?",
    "Duplungolt vendéglap?": "Double panel?",
    "Duplungolt blat?": "Double top?",
    "Kell vendéglap?": "Need panel?",
    "Blat túllógás": "Top overhang",
    "Fiók szélessége": "Drawer width",
    "Kell válaszfal?": "Need partition?",
    "Válaszfalak száma": "Partition count",
    "Ajtó szélessége": "Door width",
    "Nagy ágyvég kilógás": "Large headboard overhang",
    "Matrac szélesség": "Mattress width",
    "Matrac hosszúság": "Mattress length",
    "Matrac magasság": "Mattress height",
    "Kötés vastagság": "Rail thickness",
    "Ajtók száma": "Door count",
    "Matrac kilógás": "Mattress overhang",
    "Bal oldali fiókok száma": "Left drawer count",
    "Jobb oldali fiókok száma": "Right drawer count",
    "Fiókok száma szemből": "Front drawer count",
    "Fiók magassága": "Drawer height",
    "Kötések száma": "Rail count",
    "Duplung - kötés szélesség": "Double panel - rail width",
    "Polcok száma": "Shelf count",
    "Sütő magasság": "Oven height",
    "Fiókok száma": "Drawer count",
    "Kötés közötti távolság": "Distance between rails",
    "Nagy szekrény szélessége": "Large cabinet width",
    "Nagy szekrény mélysége + kis szekrény szélessége":
      "Large cabinet depth + small cabinet width",
    "Mikró magasság": "Microwave height",
    "Felső rész magasság": "Upper section height",
    "Duplungolt oldalak?": "Double sides?",
    "Duplungolt ágyvégek?": "Double headboards?",
    "Nagy ágyvég függőleges kilógása": "Large headboard vertical overhang",
    "Hosszú merevítések száma": "Long brace count",
    "Rövid merevítések száma": "Short brace count",
    "Jobb oldali fiókszélesség": "Right drawer width",
    "Bal oldali fiókszélesség": "Left drawer width",
    "Duplung - tömör": "Double panel - solid",
    "Mindent láthatót kantolni": "Edge all visible",
    "Plafon kötéssel": "Top with rail",
    "Van hátlemez": "Has back panel",
    "Van láb": "Has leg",
    "Elforgatott kötések": "Rotated rails",
    "Oldalak közé zár": "Locked between sides",
    "Bal oldali kis szekrény": "Left small cabinet",
    "Szemben lévő fiókok szélessége": "Facing drawer width",
    "Fiók mélység": "Drawer depth",
    "Plafon/Fenék darabszám": "Top/Bottom count",
    "Blat kilógás": "Top overhang",
    "Hátlemez darabok": "Back panel pieces",
    "Rész kiosztás": "Section layout",
    "Belső rész kiosztás": "Inner section layout",
    "Fiókos rész magassága": "Drawer section height",
    "Fiókok közötti távolság": "Distance between drawers",
    "Fiókos rész alatti távolság": "Distance below drawer section",
    "Válfás rész magassága": "Wardrobe rail section height",
    "Felső polcok száma": "Upper shelf count",
    "Alsó polcok száma": "Lower shelf count",
    "Középső polcok száma": "Middle shelf count",
    "Válfák száma": "Wardrobe rail count",
    "Alsó rész magassága": "Lower section height",
    "Belső rész típusok": "Inner section types",
    "Ajtó kilógás": "Door overhang",
    "Első ajtók száma": "Front door count",
    "Hátsó ajtók száma": "Back door count",
    "Első ajtó pozíciója": "First door position",
    "Kötés magassága": "Rail height",
    Balos: "Left-handed",
    "Fiókos rész szélessége": "Drawer section width",
    "Felső fiók magasság": "Top drawer height",
    Vízszintes: "Horizontal",

    Igen: "Yes",
    Nem: "No",
    Polcok: "Shelves",
    "Fiókos és polcos": "Drawers and shelves",
    "Fiókos és Válfás": "Drawers and wardrobe rail",
    "Válfás és polcos": "Wardrobe rail and shelves",
    Elől: "Front",
    Hátul: "Back",
    "Fiókelő és fiókoldal különbség":
      "Difference between drawer front and drawer side"
  }
};

export default settingNames;
